import { useChatStore } from "@/stores/chat-store";

// ---------------------------------------------------------------------------
// Sound Manager — lazy-loaded audio with subtle volume
// ---------------------------------------------------------------------------

type SoundName = "suggestion" | "send";

const SOUND_PATHS: Record<SoundName, string> = {
  suggestion: "/sounds/suggestion-chime.mp3",
  send: "/sounds/message-send.mp3",
};

const audioCache: Partial<Record<SoundName, HTMLAudioElement>> = {};

/**
 * Play a named sound effect. Respects the `isSoundEnabled` chat preference.
 * Audio elements are lazily created on first use and cached for reuse.
 * Autoplay restrictions are silently caught so the app never throws.
 */
export function playSound(name: SoundName): void {
  const { isSoundEnabled } = useChatStore.getState();
  if (!isSoundEnabled) return;

  let audio = audioCache[name];
  if (!audio) {
    audio = new Audio(SOUND_PATHS[name]);
    audio.volume = 0.3; // Keep sounds subtle
    audioCache[name] = audio;
  }

  audio.currentTime = 0;
  audio.play().catch(() => {
    // Silently handle autoplay restrictions
  });
}
